import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=296e1f0d"
import script from "@/views/modules/Administration/js/SystemSetting.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Administration/js/SystemSetting.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports